import { render, staticRenderFns } from "./EBillingFileTypeForm.vue?vue&type=template&id=0828897c&"
import script from "./EBillingFileTypeForm.vue?vue&type=script&lang=js&"
export * from "./EBillingFileTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./EBillingFileTypeForm.vue?vue&type=style&index=0&id=0828897c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports